import { render, staticRenderFns } from "./IntegrationMakeshop.vue?vue&type=template&id=55dbdfa2&scoped=true&"
import script from "./IntegrationMakeshop.vue?vue&type=script&lang=ts&"
export * from "./IntegrationMakeshop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbdfa2",
  null
  
)

export default component.exports